// https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API
export enum DragEventType {
	dragover = 'dragover',
}
export const ACCEPTED_DRAG_EVENT_TYPES: DragEventType[] = [DragEventType.dragover];
